import { Box } from '@mui/material';
import { FormCheckbox, LwFormTextArea } from 'redesign';
import { useFormContext } from 'react-hook-form';
import { FilterInvoiceFormContext } from './filter-invoice.types';

export const FilterInvoice = () => {
  const { watch, control } = useFormContext<FilterInvoiceFormContext>();
  const { allowInvoiceFilter } = watch();

  return (
    <Box>
      <FormCheckbox
        name="allowInvoiceFilter"
        label="Factuurnummer"
        control={control}
        isHeaderCheckbox={true}
      />
      {allowInvoiceFilter ? (
        <Box paddingLeft="30px">
          <LwFormTextArea
            name="invoiceReference"
            control={control}
            label="Factuurnummer"
            rows={1}
          />{' '}
        </Box>
      ) : null}
    </Box>
  );
};
